// extracted by mini-css-extract-plugin
export var activityContainer = "_j9-0";
export var typingIndicatorContainer = "_j9-1";
export var typingIndicatorDot = "_j9-2";
export var wave = "_j9-3";